import _ from 'lodash';

import { updateAusRelatedDataInHeaderView } from 'utils/loanHeaderView';

import { RESET_STATE } from 'store/global/actions';
import { HEADER_VIEW_ACTION_TYPE } from 'store/loanApplications/actions';

const initialState = {};

const headerViewReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case HEADER_VIEW_ACTION_TYPE.GET_LOAN_APPLICATION_HEADER_VIEW_PENDING_STATUS:
      return { ...state, isLoading: true };

    case HEADER_VIEW_ACTION_TYPE.GET_LOAN_APPLICATION_HEADER_VIEW_REJECTED_STATUS:
      return { ...state, isLoading: false };

    case HEADER_VIEW_ACTION_TYPE.GET_LOAN_APPLICATION_HEADER_VIEW:
      return { ...(payload || state), isLoading: false };

    case HEADER_VIEW_ACTION_TYPE.UPDATE_AUS_RELATED_DATA: {
      const copiedState = _.cloneDeep(state);
      const headerViewItems = _.get(copiedState, 'items');
      const items = updateAusRelatedDataInHeaderView(headerViewItems, payload);

      return {
        ...copiedState,
        items,
      };
    }

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default headerViewReducer;
